import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import localeFr from '@angular/common/locales/fr';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { registerLocaleData } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { ModalModule } from 'ngx-bootstrap/modal';
import { RequestInterceptor } from './misc/request-interceptor.misc';
import { JWT_OPTIONS, JwtHelperService } from '@auth0/angular-jwt';
import { SigninComponent } from './pages/auth/signin/signin.component';
import { ResetPasswordFormComponent } from './pages/auth/reset-password-form/reset-password-form.component';
import { ResetPasswordRequestComponent } from './pages/auth/reset-password-request/reset-password-request.component';
import { NotFoundComponent } from './pages/not-found/not-found.component';
import { CheckEmailComponent } from './pages/auth/check-email/check-email.component';
import { ResendEmailComponent } from './pages/auth/resend-email/resend-email.component';

registerLocaleData(localeFr);

@NgModule({
  declarations: [
    AppComponent,
    SigninComponent,
    ResetPasswordFormComponent,
    ResetPasswordRequestComponent,
    NotFoundComponent,
    CheckEmailComponent,
    ResendEmailComponent
  ],
   imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    HttpClientModule,
    ReactiveFormsModule,
    ModalModule.forRoot(),
  ],
  providers: [
    { provide: LOCALE_ID, useValue: "fr-FR", },
    { provide: HTTP_INTERCEPTORS, useClass: RequestInterceptor, multi: true },
    { provide: JWT_OPTIONS, useValue: JWT_OPTIONS },
    JwtHelperService,
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
